import { FC, PropsWithChildren } from 'react';

import { SectionError } from '@components/ui/error';
import { SectionLoader } from '@components/ui/loader';

import { Route } from '@/constants';

type SectionContainerProps = PropsWithChildren & {
    isLoading?: boolean;
    isError?: boolean;
    error?: unknown;
    fallbackPath?: string;
};

export const SectionContainer: FC<SectionContainerProps> = ({
    isError,
    isLoading,
    children,
    error,
    fallbackPath = Route.DASHBOARD,
}) => {
    if (isLoading) {
        return <SectionLoader />;
    }

    if (isError) {
        return <SectionError error={error} fallbackPath={fallbackPath} />;
    }

    if (!isLoading && !isError) {
        return children;
    }

    return children;
};

SectionContainer.displayName = 'SectionContainer';
